module.exports = __webpack_public_path__ + "static/img/class_task_list.40b0d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class_task_list.png
// module id = nB4u
// module chunks = 2